/**
 * Organization API module.
 *
 * Organizations are not a directory in v1 (spec §2): the only thing a user asks
 * the server is which ones they may create an island in, which is exactly what
 * the Create Island dropdown offers.
 */

import type { OrganizationSummary } from 'minka-shared';
import config from '@/env-config';
import { formatApiErrorMessage } from '@/utils/api-error';

function getAuthHeaders(): HeadersInit {
    const token = localStorage.getItem('jwt_token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
}

class OrganizationAPI {
    /**
     * Organizations the current user may create an island in (`§4.2`). An empty
     * list is a normal answer — a user with no admin island names a new
     * organization instead.
     */
    async getMyOrganizations(): Promise<OrganizationSummary[]> {
        const response = await fetch(`${config.api.baseUrl}/organizations/mine`, {
            method: 'GET',
            headers: getAuthHeaders()
        });

        const body = await response.json();

        if (!response.ok) {
            throw new Error(formatApiErrorMessage(body, 'Failed to load organizations'));
        }

        return body.data?.organizations ?? [];
    }
}

const organizationAPI = new OrganizationAPI();
export default organizationAPI;
